import React, { PureComponent } from 'react'
import { object, string, number, shape } from 'prop-types'
import { SvgPathLine } from 'components'
import { xRange, performanceVsDeteriorationPoints } from 'utils/chartFunctions'

export class PreSeasonPerformanceLine extends PureComponent {
    static propTypes = {
        curvesParams: shape({
            engine: object.isRequired,
            gearbox: object.isRequired,
            wheels: object.isRequired
        }).isRequired,
        typeSelected: string,
        outputViewBox: shape({
            x: number.isRequired,
            y: number.isRequired,
            width: number.isRequired,
            height: number.isRequired
        }).isRequired,
        factors: shape({
            engine: shape({
                x: number,
                y: number
            }),
            gearbox: shape({
                x: number,
                y: number
            }),
            wheels: shape({
                x: number,
                y: number
            })
        })
    }
    static defaultProps = {
        factors: {
            engine: { x: 1, y: 1 },
            gearbox: { x: 1, y: 1 },
            wheels: { x: 1, y: 1 }
        }
    }

    componentWillMount() {
        const { curvesParams, factors = {} } = this.props
        this.linesData = {
            engine: getLineData(curvesParams.engine, factors.engine),
            gearbox: getLineData(curvesParams.gearbox, factors.gearbox),
            wheels: getLineData(curvesParams.wheels, factors.wheels)
        }
    }

    render() {
        const { curvesParams, typeSelected, outputViewBox, factors, className, ...otherProps } = this.props
        const lineData = this.linesData[typeSelected] || null

        return (
            lineData && (
                <SvgPathLine
                    className={['ChartLine Performance', className]}
                    data={lineData}
                    inputRange={{ x: [0, 1], y: [0, 1] }}
                    outputViewBox={outputViewBox}
                    interpolated
                    startAnimation="fromBottom"
                    {...otherProps}
                />
            )
        )
    }
}

function getLineData(curveParams, factors = {}) {
    return performanceVsDeteriorationPoints(xRange(factors.x ? 1 / factors.x : 1), curveParams).map(({ x, y }) => ({
        x: factors.x ? factors.x * x : x,
        y: factors.y ? factors.y * y : y
    }))
}



// WEBPACK FOOTER //
// src/components/Svg/PreSeasonPerformanceLine.js